import { ReactElement } from 'react';
import classNames from 'classnames';
import { Props } from './index';
import './Header.scss';

export const Header = ({
  className,
  headerData,
}: Props): ReactElement => (
  <>
    <tr
      className={classNames(
        'VariantsMatrixTable-HeaderRow',
        {
          'VariantsMatrixTable-HeaderRow--First2D': headerData.secondaryTitle,
        },
        className,
      )}
    >
      {headerData.secondaryTitle && <th />}

      <th colSpan={headerData.options.length}>{headerData.title}</th>
    </tr>
    <tr
      className={classNames(
        'VariantsMatrixTable-HeaderRow',
        {
          'VariantsMatrixTable-HeaderRow--Second': !headerData.secondaryTitle,
          'VariantsMatrixTable-HeaderRow--Second2D': headerData.secondaryTitle,
        },
        className,
      )}
    >
      {headerData.secondaryTitle && <th>{headerData.secondaryTitle}</th>}

      {headerData.options.map((option) => (
        <th key={option}>{option}</th>
      ))}
    </tr>
  </>
);
